import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import { Container } from './styles';

const PageTitle = ({ titleKey }) => {
    const { t } = useTranslation();

    return (
        <Container>
            <Typography variant="title1" component="h1" color="textPrimary" noWrap>
                {t(titleKey)}
            </Typography>
        </Container>
    );
};

export default PageTitle;
